export const productTaxonomyDisplayOptions = {
  all: 'all',
  included: 'included',
  excluded: 'excluded',
}
